export default __webpack_public_path__ + "static/media/Warlord's Bolts.bbc95bdc.jpg";